import React from 'react';
import { translate } from '../Services/translation';

const BuyButton = ({ label, articleNumber, href, cssClass, onClick, loading, isSmall, isShowMore = false }) => {
    let buttonlabel = label

    if (label === undefined || label === null || label == '') {  
        if (isShowMore) {
            buttonlabel = translate('product.readMore');
        }
        else {
            buttonlabel = isSmall
                ? translate('product.buy.small') 
                : translate('product.buy');
        }
    }

    return (
        articleNumber && isShowMore == false 
            ? (
                <button className={`${cssClass} ${isSmall ? 'button--small button--buy-small' : ''} ${loading ? 'button--loading button--disabled' : ''}`} 
                    disabled={loading} 
                    onClick={() => onClick(articleNumber)}>
                    {
                        loading 
                            ? <>
                                <BuyButtonLoader /> 
                                <span>
                                    {buttonlabel}
                                </span>
                            </>
                            : <span>{buttonlabel}</span>
                    }
                </button> 
            )
            : (
                <a className={cssClass} href={href}>
                    {buttonlabel}
                </a>
            )
    )
}


const BuyButtonLoader = () => <div className="button-loader"><div></div><div></div><div></div><div></div></div>

export default BuyButton;